// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"7dfb928a","453":"567b602b"}[chunkId] + ".chunk.js";
};